import { links } from "#/shared/constants"
import { AccordionPanelItemProps, AccordionPanels } from "#/ui/Accordion"

import LearnSectionContainer from "./LearnSectionContainer"

type LearnSectionFaqProps = {
  faq: AccordionPanelItemProps[]
}

export default function LearnSectionFaq({ faq }: LearnSectionFaqProps) {
  return (
    <LearnSectionContainer
      title="FAQ"
      buttonText="See more"
      buttonProps={{
        href: links.MEZO_FAQ,
        target: "_blank",
        "data-attr": "faq_cta",
      }}
    >
      <AccordionPanels items={faq} />
    </LearnSectionContainer>
  )
}
